import { useFormContext } from 'react-hook-form'

import { FormControl, FormError, FormField, FormItem, FormLabel, SearchSelect } from '@fortem-monorepo/react-ui'

import type { useCurrencies } from '@/react-query/queries/currencies'

import { StrategyBooleanFields, StrategyNameField, StrategyTypeField } from '../shared/StrategyFields'
import type { CreateStrategyValues } from './CreateStrategyForm.schema'

export const CreateStrategyFormFields = ({
  currencies,
  strategyTypes,
  disabled,
}: {
  strategyTypes: string[]
  currencies: NonNullable<ReturnType<typeof useCurrencies>['data']>
  disabled: boolean
}) => {
  const { control } = useFormContext<CreateStrategyValues>()

  return (
    <fieldset disabled={disabled} className="space-y-4 min-w-0">
      <StrategyNameField />
      <StrategyTypeField strategyTypes={strategyTypes} disabled={disabled} />
      <FormField
        control={control}
        name="currency_id"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Currency</FormLabel>
              <FormError />
            </div>
            <FormControl>
              <SearchSelect
                size="sm"
                placeholder="Select a currency"
                name={field.name}
                value={field.value}
                setValue={field.onChange}
                onBlur={field.onBlur}
                ref={field.ref}
                disabled={disabled}
                options={currencies.map((currency) => ({ label: currency.label, value: String(currency.value) }))}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <StrategyBooleanFields disabled={disabled} />
    </fieldset>
  )
}
